import { SearchPage } from 'Components'
import TemplateSearchPage from 'Stores/shopify-rockford-turn/Templates/SearchPage.rt'
import { VehicleWidget } from 'Components'
import TemplatefitmentSearchpageHeader from 'Stores/shopify-rockford-turn/Templates/fitmentSearch/pageHeader.rt'
import TemplateCategoryPage from 'Stores/shopify-rockford-turn/Templates/CategoryPage.rt'
import { FacetTiles } from 'Components'
import TemplatefacetTileshierarchicalContainer from 'Stores/shopify-rockford-turn/Templates/facetTiles/hierarchicalContainer.rt'
import { SearchResult } from 'Components'
import { SearchHeader } from 'Components'
import { SearchBox } from 'Components'
import TemplateSearchBox from 'Stores/_default-store/Templates/SearchBox.rt'
import { SearchBoxDialogButton } from 'Components'
import TemplatesearchBoxdialogButtonMobile from 'Stores/_default-store/Templates/searchBox/dialogButtonMobile.rt'
import { Garage } from 'Components'
import TemplatefitmentSearchgarage from 'Stores/_default-store/Templates/fitmentSearch/garage.rt'
import { SingleVehicleGarage } from 'Components'
import TemplatefitmentSearchsingleVehicleGarage from 'Stores/shopify-rockford-turn/Templates/fitmentSearch/singleVehicleGarage.rt'
import TemplatefitmentSearchhomeVehicleWidget from 'Stores/_default-store/Templates/fitmentSearch/homeVehicleWidget.rt'
import { VerifyFitment } from 'Components'
import TemplatefitmentSearchverifyFitment from 'Stores/shopify-rockford-turn/Templates/fitmentSearch/verifyFitment.rt'
import { FitmentTable } from 'Components'
import TemplatefitmentSearchfitmentTableTabDesktop from 'Stores/shopify-rockford-turn/Templates/fitmentSearch/fitmentTableTabDesktop.rt'
import TemplatefitmentSearchfitmentTableTabMobile from 'Stores/shopify-rockford-turn/Templates/fitmentSearch/fitmentTableTabMobile.rt'
import TemplatefitmentSearchfitmentTable from 'Stores/_default-store/Templates/fitmentSearch/fitmentTable.rt'
import { FacetPanel } from 'Components'
import { FacetBar } from 'Components'
import { FacetDialog } from 'Components'
import TemplateFacetDialog from 'Stores/_default-store/Templates/FacetDialog.rt'
import { SearchBoxDialog } from 'Components'
import TemplateSearchBoxDialog from 'Stores/_default-store/Templates/SearchBoxDialog.rt'
import { VehicleWidgetDialog } from 'Components'
import TemplatefitmentSearchdialog from 'Stores/_default-store/Templates/fitmentSearch/dialog.rt'

export const compMap = {
  SearchPage,
VehicleWidget,
FacetTiles,
SearchResult,
SearchHeader,
SearchBox,
SearchBoxDialogButton,
Garage,
SingleVehicleGarage,
VerifyFitment,
FitmentTable,
FacetPanel,
FacetBar,
FacetDialog,
SearchBoxDialog,
VehicleWidgetDialog
} 
export const tplMap = {
  'SearchPage': TemplateSearchPage,
'fitmentSearch/pageHeader': TemplatefitmentSearchpageHeader,
'CategoryPage': TemplateCategoryPage,
'facetTiles/hierarchicalContainer': TemplatefacetTileshierarchicalContainer,
'SearchBox': TemplateSearchBox,
'searchBox/dialogButtonMobile': TemplatesearchBoxdialogButtonMobile,
'fitmentSearch/garage': TemplatefitmentSearchgarage,
'fitmentSearch/singleVehicleGarage': TemplatefitmentSearchsingleVehicleGarage,
'fitmentSearch/homeVehicleWidget': TemplatefitmentSearchhomeVehicleWidget,
'fitmentSearch/verifyFitment': TemplatefitmentSearchverifyFitment,
'fitmentSearch/fitmentTableTabDesktop': TemplatefitmentSearchfitmentTableTabDesktop,
'fitmentSearch/fitmentTableTabMobile': TemplatefitmentSearchfitmentTableTabMobile,
'fitmentSearch/fitmentTable': TemplatefitmentSearchfitmentTable,
'FacetDialog': TemplateFacetDialog,
'SearchBoxDialog': TemplateSearchBoxDialog,
'fitmentSearch/dialog': TemplatefitmentSearchdialog
};